import { useProductCategories } from "@/common/hooks/queries/useProductCategories";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { ProductCategoryData } from "@/common/types/productCategory.type";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";
import DashboardFilterSheet from "../DashboardFilterSheet";

const DashboardFilterProductCategorySheet = ({ filters, setFilters }: DashboardFilterProps) => {
  const [search, setSearch, instantSearch] = useDebounce('');

  const {
    data: productCategoriesOptions,
  } = useProductCategories({
    filters: {
      search,
    },
    mapper: Mapper.mapToOptions<ProductCategoryData>({
      labelFieldName: 'display_name',
      valueFieldName: 'id',
    }),
  });

  return (
    <DashboardFilterSheet
      filterKey={DashboardFilters.ProductCategory}
      options={productCategoriesOptions}
      filters={filters}
      setFilters={setFilters}
      instantSearch={instantSearch}
      setSearch={setSearch}
    />
  );
}

export default DashboardFilterProductCategorySheet;
